/**
 * @fileoverview A dot expressing the current value. This overlays on
 * top of the quartile box.
 */

import React from 'react'

export default function QuartileBox({ x, y1, y2, width }) {
  const height = y2 - y1

  return <rect x={x} y={y1} width={width} height={height} />
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-box/quartile-box.js